import React from 'react';
import PropTypes from 'prop-types';

import emissions from './files/Emissions_factsheet.pdf';
import forecast from './files/Forecast_factsheet.pdf';
import retina from './files/Retina_factsheet.pdf';
import atmo from './files/Atmo_factsheet.pdf';


import './style.css';

const getFile = (pdf) => {
  const file = pdf.name;
  if (file === 'Emissions_factsheet') return emissions;
  if (file === 'Forecast_factsheet') return forecast;
  if (file === 'Retina_factsheet') return retina;
  if (file === 'Atmo_factsheet') return atmo;
  return null;
};

const Download = ({ pdf }) => {
  const href = getFile(pdf);
  return (
    <div className="download-button">
      <a
        className="c-button"
        href={href || pdf.link}
        target="_blank"
        rel="noopener noreferrer"
      >
        Download {pdf.type}
      </a>
    </div>
  );
};

Download.propTypes = {
  pdf: PropTypes.shape({}).isRequired
};


export default Download;



// WEBPACK FOOTER //
// ./src/components/download/component.js